import Vue from "vue";
import CONFIG from "./../../config.js";

let actions = {
  getBillers(context, params) {
    context.commit("addLog", { request: "getBillers" });
    Vue.axios
      .get(CONFIG.getEndpoint("getBillers"), {
        withCredentials: true,
        xsrfCookieName: "SSO_TOKEN",
        params: { category: params }
      })
      .then(response => {
        // console.log(response)
        context.commit("removeLog", { request: "getBillers" });
        context.commit("set_states", response.data.states);
        context.commit("set_boards", response.data.biller);
      })
      .catch(() => {
        context.commit("removeLog", { request: "getBillers" });
      });
  },
  filterBoards(context, params) {
    context.commit("filter_boards", params);
  },
  selectState(context, params) {
    context.commit("set_state", params);
  },
  selectBoard(context, params) {
    context.commit("set_board", params);
  },
  getBill(context, params) {
    context.commit("addLog", { request: "getBill" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(CONFIG.getEndpoint("getBill"), params.params, {
          withCredentials: true,
          xsrfCookieName: "SSO_TOKEN"
        })
        .then(response => {
          context.commit("removeLog", { request: "getBill" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("removeLog", { request: "getBill" });
          reject(err);
        });
    });
  },
  createTxn(context, params) {
    context.commit("addLog", { request: "createTxn" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(CONFIG.getEndpoint("createTxn"), params.params, {
          withCredentials: true,
          xsrfCookieName: "SSO_TOKEN"
        })
        .then(response => {
          if (response.data.responseInfo.responseCode + "" !== "0") {
            const params = { referenceNumber: response.data.eplRefId };
            poll(15000, 5000, context, params)
              .then(response => {
                resolve(response);
                context.commit("removeLog", { request: "createTxn" });
              })
              .catch(err => {
                reject(err);
                context.commit("removeLog", { request: "createTxn" });
              });
          } else {
            context.commit("removeLog", { request: "createTxn" });
            resolve(response.data);
          }
        })
        .catch(err => {
          context.commit("removeLog", { request: "createTxn" });
          if (err.response) {
            reject(err);
          } else {
            resolve({
              responseInfo: {
                responseMessage: "Pending",
                responseCode: "-10"
              }
            });
          }
        });
    });
  },
  checkBillPaymentStatus(context, params) {
    context.commit("addLog", { request: "checkBillPaymentStatus" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(CONFIG.getEndpoint("checkBillPaymentStatus"), {
          withCredentials: true,
          xsrfCookieName: "SSO_TOKEN",
          params
        })
        .then(response => {
          context.commit("removeLog", { request: "checkBillPaymentStatus" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("removeLog", { request: "checkBillPaymentStatus" });
          reject(err);
        });
    });
  }
};

export default actions;
function poll(timeout, interval = 100, context, params) {
  let endTime = Number(new Date()) + (timeout || 5000);
  // console.log(context);
  let checkCondition = (resolve, reject) => {
    context
      .dispatch("checkBillPaymentStatus", params)
      .then(response => {
        if (response.responseInfo.responseCode + "" !== "-10") {
          resolve(response);
        } else if (Number(new Date()) < endTime) {
          setTimeout(checkCondition, interval, resolve, reject);
        } else {
          resolve(response);
        }
      })
      .catch(err => reject(err));
  };
  return new Promise(checkCondition);
}



// WEBPACK FOOTER //
// ./src/store/postpaid/actions.js